var React = require('react');

function One (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M27.52 4.26a4.362 4.362 0 00-5.302-.197L8.754 13.608l2.206 7.134 6.146-4.448a1.5 1.5 0 012.38 1.215v26.083l8.55.97V5.355c0-.424-.189-.826-.516-1.096zm3.516 39.985l3.464-1.002V13.404a6.5 6.5 0 00-2.164-4.842l-1.3-1.164v36.847zm-1.501-42.21a7.362 7.362 0 00-9.052-.42L6.922 11.23a2.84 2.84 0 00-1.07 3.153l2.859 9.245a1.5 1.5 0 001.01.996l6.764 1.992v18.317a1.5 1.5 0 001.33 1.49l11.551 1.31a1.5 1.5 0 00.586-.05l6.464-1.87A1.5 1.5 0 0037.5 44.37V13.404a9.5 9.5 0 00-3.163-7.077l-4.695-4.204a1.515 1.515 0 00-.107-.088zm-13.05 21.453v-3.041L13.5 22.608l2.987.88z"}));
}

One.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = One;

One.default = One;
